import React from 'react'
import { Avatar } from 'antd';
import Button2 from '../../NewComponent/Button2/Button2';
import {ReactComponent as QCount} from '../../Icons/qCount.svg';
import { bindActionCreators } from 'redux';
import { Actions } from '../../Action';
import { useDispatch } from 'react-redux';

export default function Datacard({data, id}) {
    const dispatch = useDispatch();
    const {getkeyTagPayload} = bindActionCreators(Actions, dispatch)
    const container = {
        border: '1px solid #E0E2E6',
        background: '#FFFFFF',
        padding : '24px 36px 24px 36px',
        borderRadius:'12px',
        marginBottom:'15px'
    }
    const buttonStle={
        background: 'linear-gradient(90.39deg, #00D1FF 0.34%, #0075FF 99.7%)',
        padding : '6px 12px 6px 12px',
        // border:'1px solid #F6F7F8',
        borderRadius:'8px',
        cursor:'pointer',
        // margin:'0 8px'
    }
    const onClickCard=(type)=>{
        getkeyTagPayload({tag:data.tag,key:type});
    }
  return (
    <div style={container}>
        <div style={{display:'flex', justifyContent:'space-between', flexWrap:'wrap', alignItems:'center'}}>
            <div style={{display:'flex',alignItems:'center'}}><Avatar size={'large'} style={{background:'#F6F7F8'}} ><span style={{color:'#2A364A',fontSize:'14px',fontWeight:'400'}}>#{id}</span></Avatar>&nbsp;&nbsp;<span style={{fontSize:'20px', fontWeight:'500',background:'linear-gradient(90.39deg, #00D1FF 0.34%, #0075FF 99.7%)',backgroundClip:'text','-webkitTextFillColor':'transparent'}}>{data.tag}</span></div>
            <div style={{display:'flex',alignItems:'center'}}>
            {data.expertCount !== 0 && <div style={buttonStle} onClick={()=>onClickCard('expert')}><div style={{display:'flex', justifyContent:'space-between', alignItems:'center'}}><QCount/>&nbsp;<span style={{fontSize:'14px', color:'#fff', fontWeight:'400'}}>{data.expertCount}&nbsp;Expert Responses</span></div></div>}
            &nbsp;&nbsp;
               {data.vizCount !== 0 &&<div style={buttonStle} onClick={()=>onClickCard('viz')}><div style={{display:'flex', justifyContent:'space-between', alignItems:'center'}}><QCount/>&nbsp;<span style={{fontSize:'14px', color:'#fff', fontWeight:'400'}}>{data.vizCount}&nbsp;User Queries</span></div></div>}
            </div>
        </div>
        <div className='mt-4' style={{fontSize:'16px', color:'#5C667B'}}>
            <span style={{fontSize:'16px',color:'#2A364A', fontWeight:'400'}}>Domains&nbsp;</span>
            <span style={{fontSize:'16px', color:'#5C667B', fontWeight:'300'}}>{data.domains.map((domain,ind)=>{
                if(ind !== data.domains.length-1){
                    return `${domain}, `;
                }else{
                    return `${domain}`;
                }
            })}</span>
        </div>
    </div>
  )
}
